import { ReportProperties } from './report-properties';
import { UpdateMetadata, PropertyPreviewMetadata, FieldType } from '../_services/report-template-design.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { TemplateDefinition } from './report-template';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from '../_services/lang-update.service';

export class ReportUnits extends ReportProperties {

  public onUpdateFontSizeUnit: Observable<UpdateMetadata>;
  private onUpdateFontSizeUnit$: Subject<UpdateMetadata>;
  public onUpdateSizeUnit: Observable<UpdateMetadata>;
  private onUpdateSizeUnit$: Subject<UpdateMetadata>;

  private baseDef: TemplateDefinition;
  private readonly metaFontSizeUnit = 'fontSizeUnit';
  private readonly metaSizeUnit = 'sizeUnit';

  constructor(templateDef: TemplateDefinition,
    protected translate: TranslateService,
    protected langService: LangUpdateService
) {
    super('Size Unit', translate, langService);
    this.onUpdateFontSizeUnit$ = new Subject<UpdateMetadata>();
    this.onUpdateFontSizeUnit = this.onUpdateFontSizeUnit$.asObservable();
    this.onUpdateSizeUnit$ = new Subject<UpdateMetadata>();
    this.onUpdateSizeUnit = this.onUpdateSizeUnit$.asObservable();

    this.baseDef = templateDef;

    this.setChainUpdate();
    this.setPreviewMetadata();
  }

  public concatenate(useUnit: 'fontSizeUnit' | 'sizeUnit', value: number): string {
    let rtn = '';
    if (value != null) {
      const tmp: Array<string> = [];
      tmp.push(value.toString());
      tmp.push(this.baseDef[useUnit]);
      rtn = tmp.join('');
    }
    return rtn;
  }

  public toPx(useUnit: 'fontSizeUnit' | 'sizeUnit', value: number): number {
    return this.toPixel(value, this.baseDef[useUnit]);
  }

  public fromPx(useUnit: 'fontSizeUnit' | 'sizeUnit', value: number): number {
    return this.fromPixel(value, this.baseDef[useUnit]);
  }

  public getTemplateJSON(): TemplateDefinition {
    return this.baseDef;
  }

  protected getPreviewMetadata(): PropertyPreviewMetadata[] {
    return [
      {
        name: this.metaFontSizeUnit, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'px', value: 'px' },
          { label: 'mm', value: 'mm' },
          { label: 'cm', value: 'cm' },
          { label: 'in', value: 'in' },
          { label: 'pt', value: 'pt' },
        ], // ↑ 他にも選択肢を増やす場合は、ReportProperties.fromPixel(),.toPixel()に定義した計算式も併せて増やすこと。
        isRequired: true,
        isEdited: false,
        isDisplay: true,
      },
      {
        name: this.metaSizeUnit, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'px', value: 'px' },
          { label: 'mm', value: 'mm' },
          { label: 'cm', value: 'cm' },
          { label: 'in', value: 'in' },
        ], // ↑ 他にも選択肢を増やす場合は、ReportProperties.fromPixel(),.toPixel()に定義した計算式も併せて増やすこと。
        isRequired: true,
        isEdited: false,
        isDisplay: true,
      }
    ];
  }

  protected setUpdateMetadata(metadata: UpdateMetadata) {
    switch (metadata.name) {
      case this.metaFontSizeUnit:
        this.baseDef[metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateFontSizeUnit$.next(metadata);
        break;
      case this.metaSizeUnit:
        this.baseDef[metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateSizeUnit$.next(metadata);
        break;
    }
  }

  protected setChainUpdateFunction(subscribers: Array<Subscription>) {
    // 他のオブジェクトが持つ値が更新されたことによって、自身が持つプロパティを更新するパターンは無いため、NOP
  }
}
